import { Info, InfoFill } from "./Info";

import './InfoBar.scss'

export default function InfoBar({ title, children, icon, className, onClick = null }) {
    const classes = ['InfoBar'];
    if (className) {
        classes.push(className);
    }
    if (onClick) {
        classes.push('clickable');
    }
    return <div
        className={classes.join(' ')}
        onClick={onClick}>
        {icon ? <div className="InfoBar__icon">
            {icon}
        </div> : null}
        <div className="InfoBar__content">

            {children}
        </div>
    </div>
}